import PropTypes from "prop-types";

/**
 * User Shape
 * Shape for user data objects used throughout the application
 *
 * @typedef {Object} User
 * @property {string|number} [id] - Unique user identifier
 * @property {string} [name] - User's full name
 * @property {string} [email] - User's email address
 * @property {('Admin'|'User'|'Operator')} [userPrivileges] - User role/permission level
 * @property {string} [avatar] - URL or path to user's avatar image
 */
export const userShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  email: PropTypes.string,
  userPrivileges: PropTypes.oneOf(["Admin", "User", "Operator"]),
  avatar: PropTypes.string,
});
